import React from "react";
import styled from "styled-components";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { graphql } from "gatsby";

import ContentModal from "Components/common/base/contentModal";

const StyledWrapper = styled.div`
  background-color: ${(props) => props.theme.color[props.backgroundColor]};
  color: ${(props) => props.theme.color[props.textColor]};
  padding: 3rem 1rem;
  display: flex;
  flex-direction: column-reverse;
  ${(props) => props.theme.responsive.mobile} {
    flex-direction: ${(props) =>
      props.align === "left" ? "row" : "row-reverse"};
    align-items: center;
  }
`;
const StyledContentWrapper = styled.div`
  width: 100%;
  ${(props) => props.theme.responsive.mobile} {
    width: 50%;
  }
`;
const StyledAsset = styled.div`
  width: 100%;
  margin-bottom: 1rem;
  margin-left: 0rem;
  margin-right: 0rem;
  ${(props) => props.theme.responsive.mobile} {
    width: 50%;
    margin-left: ${(props) => (props.align === "left" ? 3 : 0)}rem;
    margin-right: ${(props) => (props.align === "left" ? 0 : 3)}rem;
  }
`;

export default function BlurbModal({
  align,
  content,
  asset,
  textColor,
  backgroundColor,
}) {
  return (
    <StyledWrapper
      align={align}
      backgroundColor={backgroundColor && backgroundColor.color}
      textColor={textColor && textColor.color}
    >
      <StyledContentWrapper>
        <ContentModal {...content} />
      </StyledContentWrapper>
      {asset && (
        <StyledAsset align={align}>
          {asset.ext === ".gif" ? (
            <img src={asset.url} alt="Image" />
          ) : (
            <GatsbyImage
              imgStyle={{
                objectFit: "cover",
                objectPosition: "center center",
              }}
              style={{ width: "100%", height: "100%" }}
              alt="Image"
              image={getImage(asset.imageFile)}
            />
          )}
        </StyledAsset>
      )}
    </StyledWrapper>
  );
}

export const query = graphql`
  fragment blurbModal on STRAPI_ComponentBaseBlurbModal {
    __typename
    id
    align
    asset {
      url
      ext
      imageFile {
        childImageSharp {
          gatsbyImageData(
            layout: FULL_WIDTH
            placeholder: BLURRED
            formats: AUTO
          )
        }
      }
    }
    content {
      subtitle {
        en
        es
        it
      }
      title {
        en
        es
        it
      }
      content {
        en
        es
        it
      }
      ctas {
        label {
          en
          es
          it
        }
        link
        type
      }
    }
    textColor {
      color
    }
    backgroundColor {
      color
    }
  }
`;
